/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessSourceMonthlyStat
 */
export interface BusinessSourceMonthlyStat {
    /**
     * 业务类型名称
     * @type {string}
     * @memberof BusinessSourceMonthlyStat
     */
    typeName?: string;
    /**
     * 代买订单数量
     * @type {number}
     * @memberof BusinessSourceMonthlyStat
     */
    buyingCount?: number;
    /**
     * 转运订单数量
     * @type {number}
     * @memberof BusinessSourceMonthlyStat
     */
    transferCount?: number;
    /**
     * 代买占比(%)
     * @type {number}
     * @memberof BusinessSourceMonthlyStat
     */
    buyingPercentage?: number;
    /**
     * 转运占比(%)
     * @type {number}
     * @memberof BusinessSourceMonthlyStat
     */
    transferPercentage?: number;
    /**
     * 代买环比上月增长率(%)
     * @type {number}
     * @memberof BusinessSourceMonthlyStat
     */
    buyingMomGrowthRate?: number;
    /**
     * 转运环比上月增长率(%)
     * @type {number}
     * @memberof BusinessSourceMonthlyStat
     */
    transferMomGrowthRate?: number;
    /**
     * 合计
     * @type {number}
     * @memberof BusinessSourceMonthlyStat
     */
    total?: number;
}

/**
 * Check if a given object implements the BusinessSourceMonthlyStat interface.
 */
export function instanceOfBusinessSourceMonthlyStat(value: object): value is BusinessSourceMonthlyStat {
    return true;
}

export function BusinessSourceMonthlyStatFromJSON(json: any): BusinessSourceMonthlyStat {
    return BusinessSourceMonthlyStatFromJSONTyped(json, false);
}

export function BusinessSourceMonthlyStatFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessSourceMonthlyStat {
    if (json == null) {
        return json;
    }
    return {
        
        'typeName': json['typeName'] == null ? undefined : json['typeName'],
        'buyingCount': json['buyingCount'] == null ? undefined : json['buyingCount'],
        'transferCount': json['transferCount'] == null ? undefined : json['transferCount'],
        'buyingPercentage': json['buyingPercentage'] == null ? undefined : json['buyingPercentage'],
        'transferPercentage': json['transferPercentage'] == null ? undefined : json['transferPercentage'],
        'buyingMomGrowthRate': json['buyingMomGrowthRate'] == null ? undefined : json['buyingMomGrowthRate'],
        'transferMomGrowthRate': json['transferMomGrowthRate'] == null ? undefined : json['transferMomGrowthRate'],
        'total': json['total'] == null ? undefined : json['total'],
    };
}

export function BusinessSourceMonthlyStatToJSON(json: any): BusinessSourceMonthlyStat {
    return BusinessSourceMonthlyStatToJSONTyped(json, false);
}

export function BusinessSourceMonthlyStatToJSONTyped(value?: BusinessSourceMonthlyStat | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'typeName': value['typeName'],
        'buyingCount': value['buyingCount'],
        'transferCount': value['transferCount'],
        'buyingPercentage': value['buyingPercentage'],
        'transferPercentage': value['transferPercentage'],
        'buyingMomGrowthRate': value['buyingMomGrowthRate'],
        'transferMomGrowthRate': value['transferMomGrowthRate'],
        'total': value['total'],
    };
}

